import { createSlice } from '@reduxjs/toolkit'

const {
  actions: {
    superAdminLoginStart,
    superAdminLoginSuccess,
    superAdminLoginFailure,
    tenantLoginStart,
    tenantLoginSuccess,
    tenantLoginFailure,
    fetchTenantDetailsStart,
    fetchTenantDetailsSuccess,
    fetchTenantDetailsFailure,
    getAdminRoleStart,
    getAdminRoleSuccess,
    getAdminRoleFailure,
    getTenantRoleStart,
    getTenantRoleSuccess,
    getTenantRoleFailure,
    getTenantAdminRoleStart,
    getTenantAdminRoleSuccess,
    getTenantAdminRoleFailure,
    getTenantWalletStart,
    getTenantWalletSuccess,
    getTenantWalletFailure,
    getSuperAdminWalletStart,
    getSuperAdminWalletSuccess,
    getSuperAdminWalletFailure,
    updateProfileStart,
    getAdminConfigurationStart,
    getAdminConfigurationComplete,
    createAdminConfigurationStart,
    createAdminConfigurationComplete,
    updateAdminConfigurationStart,
    updateAdminConfigurationComplete,
    updateSiteConfigurationStart,
    updateSiteConfigurationComplete,
    updateProfileComplete,
    setEmailCredsStart,
    setEmailCredsComplete,
    sendMailStart,
    sendMailComplete,
    resetPasswordStart,
    resetPasswordComplete,
    resetProfilePasswordStart,
    resetProfilePasswordComplete,
    clearVerificationState
  },
  reducer
} = createSlice({
  name: 'login',
  initialState: {
    loading: false,
    isLoggedIn: false,
    error: null,
    success: false,
    userId: null,
    role: null,
    tenantDetails: null,
    adminRole: null,
    tenantAdminRole: null,
    wallets: null,
    verificationCode: null,
    tempAccessToken: null,
    requiresVerification: false
  },
  reducers: {
    superAdminLoginStart: (state) => ({
      ...state,
      loading: true,
      error: null
    }),
    superAdminLoginSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      isLoggedIn: !payload.requiresVerification,
      error: null,
      success: true,
      role: payload.role,
      userId: payload.loggedInUserId,
      verificationCode: payload.verificationCode,
      tempAccessToken: payload.tempAccessToken,
      requiresVerification: payload.requiresVerification
    }),
    superAdminLoginFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
      success: false,
      isLoggedIn: false
    }),
    tenantLoginStart: (state) => ({
      ...state,
      loading: true
    }),
    tenantLoginSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      isLoggedIn: true,
      error: null,
      success: true,
      role: payload
    }),
    tenantLoginFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      isLoggedIn: false,
      error: payload,
      success: false
    }),
    fetchTenantDetailsStart: (state) => ({
      ...state,
      loading: true,
      tenantDetails: null
    }),
    fetchTenantDetailsSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      tenantDetails: payload
    }),
    fetchTenantDetailsFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload
    }),
    getAdminRoleStart: (state) => ({
      ...state,
      loading: true
    }),
    getAdminRoleSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      adminRole: payload
    }),
    getAdminRoleFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
      success: false
    }),
    getTenantRoleStart: (state) => ({
      ...state,
      loading: true
    }),
    getTenantRoleSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      tenantAdminRole: payload
    }),
    getTenantRoleFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
      success: false
    }),
    getTenantAdminRoleStart: (state) => ({
      ...state,
      loading: true
    }),
    getTenantAdminRoleSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      tenantAdminRole: payload
    }),
    getTenantAdminRoleFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
      success: false
    }),
    getTenantWalletStart: (state) => ({
      ...state,
      loading: true
    }),
    getTenantWalletSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      wallets: payload
    }),
    getTenantWalletFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
      success: false
    }),
    getSuperAdminWalletStart: (state) => ({
      ...state,
      loading: true
    }),
    getSuperAdminWalletSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      wallets: payload
    }),
    getSuperAdminWalletFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
      success: false
    }),
    updateSiteConfigurationStart: (state) => ({
      ...state,
      loading: true
    }),
    updateSiteConfigurationComplete: (state) => ({
      ...state,
      loading: false
    }),
    getAdminConfigurationStart: (state) => ({
      ...state,
      loading: true
    }),
    getAdminConfigurationComplete: (state) => ({
      ...state,
      loading: false
    }),
    createAdminConfigurationStart: (state) => ({
      ...state,
      loading: true
    }),
    createAdminConfigurationComplete: (state) => ({
      ...state,
      loading: false
    }),
    updateAdminConfigurationStart: (state) => ({
      ...state,
      loading: true
    }),
    updateAdminConfigurationComplete: (state) => ({
      ...state,
      loading: false
    }),
    updateProfileStart: (state) => ({
      ...state,
      loading: true
    }),
    updateProfileComplete: (state) => ({
      ...state,
      loading: false
    }),
    setEmailCredsStart: (state) => ({
      ...state,
      loading: true
    }),
    setEmailCredsComplete: (state) => ({
      ...state,
      loading: false
    }),
    sendMailStart: (state) => ({
      ...state,
      sendMailLoading: true
    }),
    sendMailComplete: (state) => ({
      ...state,
      sendMailLoading: false
    }),
    resetPasswordStart: (state) => ({
      ...state,
      resetPassLoading: true
    }),
    resetPasswordComplete: (state) => ({
      ...state,
      resetPassLoading: false
    }),
    resetProfilePasswordStart: (state) => ({
      ...state,
      resetPassLoading: true
    }),
    resetProfilePasswordComplete: (state) => ({
      ...state,
      resetPassLoading: false
    }),
    clearVerificationState: (state) => ({
      ...state,
      verificationCode: null,
      tempAccessToken: null,
      requiresVerification: false,
      error: null
    })
  }
})

export default reducer

export {
  superAdminLoginStart,
  superAdminLoginSuccess,
  superAdminLoginFailure,
  tenantLoginStart,
  tenantLoginSuccess,
  tenantLoginFailure,
  fetchTenantDetailsStart,
  fetchTenantDetailsSuccess,
  fetchTenantDetailsFailure,
  getAdminRoleStart,
  getAdminRoleSuccess,
  getAdminRoleFailure,
  getTenantRoleStart,
  getTenantRoleSuccess,
  getTenantRoleFailure,
  getTenantAdminRoleStart,
  getTenantAdminRoleSuccess,
  getTenantAdminRoleFailure,
  getTenantWalletStart,
  getTenantWalletSuccess,
  getTenantWalletFailure,
  getSuperAdminWalletStart,
  getSuperAdminWalletSuccess,
  getSuperAdminWalletFailure,
  updateProfileStart,
  getAdminConfigurationStart,
  getAdminConfigurationComplete,
  createAdminConfigurationStart,
  createAdminConfigurationComplete,
  updateAdminConfigurationStart,
  updateAdminConfigurationComplete,
  updateSiteConfigurationStart,
  updateSiteConfigurationComplete,
  updateProfileComplete,
  setEmailCredsStart,
  setEmailCredsComplete,
  sendMailStart,
  sendMailComplete,
  resetPasswordStart,
  resetPasswordComplete,
  resetProfilePasswordStart,
  resetProfilePasswordComplete,
  clearVerificationState
}
